// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2003":"ee9c64e478a4a6fd","9335":"e7e5e050ed20a67d","9820":"232be96ea0998e42"}[chunkId] + ".css";
};